import React from 'react';
import RegistrationForm from './RegistrationForm';
import './App.css';

function App() {
  return (
    <div className="app-container">
      {/* Centered Logo - Double the size */}
      <div className="logo-section">
        <img src="/csri.jpg" alt="CSRI Logo" style={{ maxWidth: '440px' }} />
      </div>

      <header className="hero-section">
        <h1>Empowering Future Strategists</h1>
        <p style={{ marginBottom: '10px' }}> {/* Removed large bottom gap from paragraph */}
          The Ceylon Strategic Research Institute (CSRI) zealously engages in discovering new knowledge to usher an innovative new era. 
          Register below to connect your academic excellence with professional industry opportunities.
        </p>
        
        {/* Main Header - Margin bottom removed to merge with sub-header */}
        <h2 style={{ fontSize: '24px', color: '#c5a059', textAlign: 'center', marginTop: '20px', marginBottom: '0', textTransform: 'uppercase' }}>
          Job Application Form      
        </h2>
        {/* Sub-header - Margin top removed to sit directly below main header */}
        <h3 style={{ marginTop: '0', textAlign: 'center', border: 'none', padding: '0' }}> 
          (Earn While Learn Program)
        </h3>
      </header>

      <RegistrationForm />
    </div>
  );
}

export default App;